import React from "react";
const LockSVG = ({ color = "black", className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      className={className}
    >
      <path
        d="M6.86667 9.55556C5.95317 9.55556 5.24285 9.55556 4.66667 9.59076C3.94761 9.63463 3.43747 9.73339 3.00204 9.95522C2.3121 10.3067 1.75118 10.8676 1.39964 11.5576C1 12.342 1 13.3686 1 15.4222V17.1333C1 19.1869 1 20.2136 1.39964 20.998C1.75118 21.6879 2.3121 22.2488 3.00204 22.6003C3.78637 23 4.81314 23 6.86667 23H14.6889C16.7425 23 17.7691 23 18.5536 22.6003C19.2435 22.2488 19.8044 21.6879 20.1559 20.998C20.5556 20.2136 20.5556 19.1869 20.5556 17.1333V15.4222C20.5556 13.3686 20.5556 12.342 20.1559 11.5576C19.8044 10.8676 19.2435 10.3067 18.5536 9.95522C18.1181 9.73339 17.6079 9.63463 16.8889 9.59076C16.3127 9.55556 15.6024 9.55556 14.6889 9.55556H6.86667Z"
        fill={color}
      />
      <path
        d="M4.66667 9.59076C5.24285 9.55556 5.95317 9.55556 6.86667 9.55556H14.6889C15.6024 9.55556 16.3127 9.55556 16.8889 9.59076M4.66667 9.59076C3.94761 9.63463 3.43747 9.73339 3.00204 9.95522C2.3121 10.3067 1.75118 10.8676 1.39964 11.5576C1 12.342 1 13.3686 1 15.4222V17.1333C1 19.1869 1 20.2136 1.39964 20.998C1.75118 21.6879 2.3121 22.2488 3.00204 22.6003C3.78637 23 4.81314 23 6.86667 23H14.6889C16.7425 23 17.7691 23 18.5536 22.6003C19.2435 22.2488 19.8044 21.6879 20.1559 20.998C20.5556 20.2136 20.5556 19.1869 20.5556 17.1333V15.4222C20.5556 13.3686 20.5556 12.342 20.1559 11.5576C19.8044 10.8676 19.2435 10.3067 18.5536 9.95522C18.1181 9.73339 17.6079 9.63463 16.8889 9.59076M4.66667 9.59076V7.11111C4.66667 3.73604 7.40271 1 10.7778 1C14.1528 1 16.8889 3.73604 16.8889 7.11111V9.59076"
        stroke="#787878"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LockSVG;
